import { Stack } from '@mui/material';
import styled from 'styled-components';
import { theme } from 'styles/mui-config'


export const StyledStack = styled(Stack)`
   background-color: ${theme.palette.secondary.light};
   border-radius: 4px;
   box-shadow: 0 0 5px ${theme.palette.shadow.main};
   margin-top:30px;
   width:100%;
   padding:20px;
   padding-top:0px;
`